let deliberate = false

export function markDeliberateSignOut(): void {
  deliberate = true
}

export function clearDeliberateSignOut(): void {
  deliberate = false
}

export function isDeliberateSignOut(): boolean {
  return deliberate
}
